import { useContext } from 'react';

import { ChainSelectorsContext } from '../context';

export const useChainSelectors = () => useContext(ChainSelectorsContext);
